import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { environment } from 'src/environments/environment';
import { SharedModule } from './shared/shared.module';
import { AuthService } from './core/services/auth/auth.service';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { ThemeService } from './shared/services/theme/theme';
import { LoaderInterceptor } from './core/interceptors/loader.interceptor';

export function themeInit(theme: ThemeService) {
  return () => theme.init(environment.defaultTheme);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    LayoutModule,
    SharedModule
  ],
  providers: [
    { provide: APP_INITIALIZER, useFactory: themeInit, deps: [ThemeService], multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    AuthService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
